import React from "react";
import { useTheme } from "@emotion/react";
import { MarkdownView } from "react-native-markdown-view";
import { getTextStyles } from "../../utils/styles";

const MarkdownText = ({ children }) => {
	const theme: any = useTheme();
	return (
		<MarkdownView styles={getTextStyles(theme)}>{children}</MarkdownView>
	);
};

export default MarkdownText;
